import React, { useEffect, useRef } from "react";
import { reduxForm } from "redux-form";
import { Button } from "cxa-components";
import { StringField } from "cxa-form-field";
import FormHeading from "components/common/FormHeading";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const ChangePasswordForm = ({
  handleSubmit,
  submitting,
  submitted,
  response,
  error,
  resetExpiredPasswordMode,
  intl,
  policyDescription,
  reset,
  isNewUI,
}) => {
  useEffect(() => {
    window.propintl = intl;
  }, [intl]);

  const title = resetExpiredPasswordMode
    ? intl.formatMessage(messages.resetExpiredPasswordDescription)
    : intl.formatMessage(messages.changePasswordDescription);
  const saveButton = resetExpiredPasswordMode
    ? intl.formatMessage(messages.resetPasswordDescription)
    : intl.formatMessage(messages.updateNewPasswordDescription);

  return (
    <form className="cxa-c-form" onSubmit={handleSubmit} autoComplete="off">
      <FormHeading
        title={intl.formatMessage({ id: title, defaultMessage: title })}
      />
      <section className="change-password-form">
        <fieldset>
          <StringField
            className={isNewUI && "change-password-label"}
            label={intl.formatMessage(messages.currentPasswordDescription)}
            name="currentPassword"
            type="password"
            required
            boxed
            newUIFlag={isNewUI}
          />
          <StringField
            className={isNewUI && "change-password-label"}
            label={intl.formatMessage(messages.newPasswordDescription)}
            name="newPassword"
            type="password"
            required
            boxed
            newUIFlag={isNewUI}
          />
          <StringField
            className={isNewUI && "change-password-label"}
            label={intl.formatMessage(messages.retypeNewPasswordDescription)}
            name="repeatNewPassword"
            type="password"
            required
            boxed
            newUIFlag={isNewUI}
          />
        </fieldset>
        <p style={{ whiteSpace: "pre-line", fontSize: "18px", color: "#353535" }}>
            {intl.formatMessage({id: "config.passwordPolicy", defaultMessage: policyDescription})}
        </p>        

        {error && reset() && null}
        {submitted && !error && response ? (
          <p>
            {intl.formatMessage({
              id: response.body.changeMessage,
              defaultMessage: response.body.changeMessage,
            })}
          </p>
        ) : null}
      </section>
      <p>
        <Button primary submitting={submitting}>{saveButton}</Button>
      </p>
    </form>
  );
};

ChangePasswordForm.propTypes = {
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  submitted: PropTypes.bool,
  response: PropTypes.object,
  error: PropTypes.object,
  resetExpiredPasswordMode: PropTypes.bool,
  intl: intlShape.isRequired,
  validateRequired: PropTypes.func,
  policyDescription: PropTypes.string,
  reset: PropTypes.func,
  isNewUI: PropTypes.bool,
};

const validateForm = (values, { intl }) => {
  const errors = {};
  if (!values.currentPassword) {
    errors.currentPassword = intl
      ? intl.formatMessage(messages.requiredDescription)
      : "Required";
  }
  if (!values.newPassword) {
    errors.newPassword = intl
      ? intl.formatMessage(messages.requiredDescription)
      : "Required";
  }
  if (!values.repeatNewPassword) {
    errors.repeatNewPassword = intl
      ? intl.formatMessage(messages.requiredDescription)
      : "Required";
  }
  if (values.newPassword !== values.repeatNewPassword) {
    errors.repeatNewPassword = intl
      ? intl.formatMessage(messages.passwordNotMatchDescription)
      : messages.passwordNotMatchDescription.defaultMessage;
  }
  return errors;
};

const mapStateToProps = ({ common }) => {
  const isNewUI = common.clientSettings.newUIFlag;

  return {
    isNewUI,
  };
};

const ChangePasswordFormContainer = connect(mapStateToProps)(ChangePasswordForm);

export default injectIntl(
  reduxForm({
    form: "changePasswordForm",
    validate: validateForm,
  })(ChangePasswordFormContainer)
);



// WEBPACK FOOTER //
// ./components/password/ChangePasswordForm.js